module.exports = __webpack_public_path__ + "static/img/59.b034052.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/59.png
// module id = 87MY
// module chunks = 0